import { __assign } from '../external/tslib/tslib.es6.mjs.js';
import { jsxs, jsx } from 'react/jsx-runtime';

var PlusIcon = function (_a) {
    var className = _a.className;
    return (jsxs("svg", __assign({ className: className, width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsx("title", { children: "Plus sign" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 12V21.5H12V12H21.5V10H12V0.5H10V10H0.5V12H10Z", fill: "currentColor" })] })));
};

export { PlusIcon };
